import { render } from "./RemoveForm.vue?vue&type=template&id=437c3690&scoped=true"
import script from "./RemoveForm.vue?vue&type=script&lang=js"
export * from "./RemoveForm.vue?vue&type=script&lang=js"

import "./RemoveForm.vue?vue&type=style&index=0&id=437c3690&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c3690"]])

export default __exports__